export default __webpack_public_path__ + "b650a1d0af1cf772226e908e41778424.svg";